import WebsiteUnderMaintenance from "./pages/websiteundermaintance";

const App = () => {
  // MAINTENANCE MODE: All pages redirect to maintenance page
  const isMaintenanceMode = true;

  if (isMaintenanceMode) {
    return <WebsiteUnderMaintenance />;
  }

  // Original routing code (uncomment to disable maintenance mode)
  /*
  import { Suspense, lazy } from "react";
  import { Routes, Route } from "react-router-dom";
  import Navbar from "./Components/Navbar";
  import TopBar from "./Components/TopBar";
  import Footer from "./Components/Footer";
  import Loader from "./Components/Loader";
  import Home from "./pages/Home";
  import About from "./pages/About";
  
  const Services = lazy(() => import("./pages/Services"));
  const Contact = lazy(() => import("./pages/Contact"));
  const Join = lazy(() => import("./pages/Join"));
  const Leads = lazy(() => import("./pages/Leads"));
  const CategoryPage = lazy(() => import("./pages/CategoryPage"));
  const FeatureDetail = lazy(() => import("./pages/FeatureDetail"));
  const Testimonials = lazy(() => import("./pages/Testimonials"));
  const Teacherr = lazy(() => import("./pages/Teacherr"));
  
  return (
    <>
      <TopBar />
      <Navbar />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/teacher" element={<Teacherr />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/join" element={<Join />} />
          <Route path="/leads" element={<Leads />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/category/:id" element={<CategoryPage />} />
          <Route path="/feature/:id" element={<FeatureDetail />} />
        </Routes>
      </Suspense>
      <Footer />
    </>
  );
  */
};

export default App;
